import { format } from "date-fns";
import ISiteDiaryItemOrderViewModel from "interfaces/SiteDiary/ItemOrder/ISiteDiaryItemOrderViewModel";
import { itemOrderStatusClasses } from "modules/ItemOrderStatusClasses";

const StatusTemplate = (props: ISiteDiaryItemOrderViewModel): any => {
  const { updatedDate, status } = props;
  return (
    <span data-testid="itemStatus">
      <span className={`${itemOrderStatusClasses[status]} fw-bold`}>{status}</span>
      <br />
      <span>{format(updatedDate, "dd MMM yyyy")}</span>
    </span>
  );
};
export default StatusTemplate;
